import * as yup from "yup";

const IP_REGEX =
  /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

const NAME_REGEX = /^[0-9a-z-]+$/;

const schema = yup.object().shape({
  ipAddress: yup
    .string()
    .required("This field is required")
    .matches(IP_REGEX, "Invalid IP Address"),

  priority: yup
    .number()
    .required("This field is required")
    .min(0, "Value must be between 0 and 65535")
    .max(65535, "Value must be between 0 and 65535"),

  weight: yup
    .number()
    .required("This field is required")
    .min(0, "Value must be between 0 and 65535")
    .max(65535, "Value must be between 0 and 65535"),

  port: yup
    .number()
    .required("This field is required")
    .min(0, "Value must be between 0 and 65535")
    .max(65535, "Value must be between 0 and 65535"),

  name: yup
    .string()
    .required("This field is required")
    .min(3, "Gateway name should be between 3 and 25 characters.")
    .max(25, "Gateway name should be between 3 and 25 characters.")
    .matches(
      NAME_REGEX,
      "The name should only contain a-z letters, numbers, and '-'"
    ),
});

export default schema;
